import { useState } from "react";
import { useReveal } from "../hooks";

const ROLES = [
  { t: "BDR", full: "Business Development Rep", d: "Your entry into the field. Learn the Swift pitch system, master door-to-door and event-based conversations, and get paid on every close from week one. No experience required — we train from zero." },
  { t: "AE", full: "Account Executive", d: "Consistent closers step up to bigger territories and higher-value offers, including B2B telecom accounts and full home-energy packages. Larger commissions, direct mentorship from managers." },
  { t: "TM", full: "Team Manager", d: "Run your own crew of 5–10 reps. You recruit, coach in the field, and earn overrides on everything your team closes — leadership measured in revenue, not meetings." },
  { t: "DIR", full: "Director", d: "Own an entire market or division. Directors design campaigns with partner brands, manage multiple teams, and share in divisional profit." },
  { t: "JP", full: "Junior Partner", d: "The top of the progression: equity-level participation in Swift's growth. Junior Partners open new markets and new divisions — like Swift Energy — from the ground up." },
];

export const Careers = () => {
  const [ref, inView] = useReveal(0.25);
  const [active, setActive] = useState(0);
  const role = ROLES[active];
  return (
    <section className="sec" id="careers" data-testid="careers-section" ref={ref}>
      <div className="container">
        <div className={`reveal ${inView ? "in" : ""}`}>
          <span className="eyebrow">Careers</span>
          <h2 className="h-display">A path from first pitch to partner</h2>
          <p className="lead">
            Every leader at Swift started in the field. Promotion is earned on performance —
            never on tenure.
          </p>
        </div>
        <div className={`careers-path reveal d1 ${inView ? "in" : ""}`}>
          <div className={`careers-line ${inView ? "in" : ""}`}><i /></div>
          <div className="careers-steps">
            {ROLES.map((r, i) => (
              <button key={i} className={`career-step ${i === active ? "active" : ""}`} onClick={() => setActive(i)} data-testid={`career-step-${i}`}>
                <span className="career-dot">{r.t}</span>
                <span>
                  <h4>{r.full}</h4>
                  <span className="lv">Level 0{i + 1}</span>
                </span>
              </button>
            ))}
          </div>
          <div className="career-detail" data-testid="career-detail">
            <div>
              <h3>{role.full}</h3>
              <p>{role.d}</p>
            </div>
            <a className="btn" href={`mailto:info@swiftmarketing.ca?subject=Application — ${role.full}`} data-testid="career-apply-btn">
              Apply now →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
